import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
} from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import AcxButton from "components/UI/AcxButton/AcxButton";
import { TYPE_OPTIONS, DialogState } from "./constants";

interface AddSchemaDialogProps {
    open: boolean;
    onClose: () => void;
    onAdd: (dialogState: DialogState) => void;
    dialogState: DialogState;
    onDialogStateChange: (state: DialogState) => void;
    title: string;
    showNameField?: boolean;
}

export function AddSchemaDialog({
    open,
    onClose,
    onAdd,
    dialogState,
    onDialogStateChange,
    title,
    showNameField = true,
}: AddSchemaDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} sx={{ marginTop: 2 }}>
                    {showNameField && (
                        <AcxMainTextField
                            id="schema-name"
                            labelText="Name"
                            placeholderText="e.g., username"
                            value={dialogState.name}
                            onChange={(e) =>
                                onDialogStateChange({
                                    ...dialogState,
                                    name: e.target.value,
                                })
                            }
                            fullWidth
                        />
                    )}
                    <AcxSelectSingle
                        id="schema-type"
                        options={TYPE_OPTIONS}
                        valueField="value"
                        labelField="label"
                        key={`schema-type-${open}`}
                        defaultValue={TYPE_OPTIONS.find(
                            (opt) => opt.value === dialogState.type,
                        )}
                        onChange={(selected) => {
                            if (selected) {
                                onDialogStateChange({
                                    ...dialogState,
                                    type: selected.value,
                                });
                            }
                        }}
                        inputLabel="Type"
                        fullWidth
                    />
                    <AcxMainTextField
                        id="schema-title"
                        labelText="Title (optional)"
                        placeholderText="e.g., Username"
                        value={dialogState.title}
                        onChange={(e) =>
                            onDialogStateChange({
                                ...dialogState,
                                title: e.target.value,
                            })
                        }
                        fullWidth
                    />
                    <AcxMainTextField
                        id="schema-description"
                        labelText="Description (optional)"
                        placeholderText="Describe this field"
                        value={dialogState.description}
                        onChange={(e) =>
                            onDialogStateChange({
                                ...dialogState,
                                description: e.target.value,
                            })
                        }
                        multiline
                        fullWidth
                        rowsMin={3}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <AcxButton onClick={onClose} color="white">
                    Cancel
                </AcxButton>
                <AcxButton
                    onClick={() => onAdd(dialogState)}
                    color="primary"
                    disabled={showNameField && !dialogState.name.trim()}
                >
                    Add
                </AcxButton>
            </DialogActions>
        </Dialog>
    );
}
